import React from 'react';
import { Link } from 'react-router-dom';

// Student-facing data tools. Add new tools here and they appear on the hub.
const TOOLS = [
  {
    to: '/college-tools',
    emoji: '🎓',
    title: 'College Peer Map & Similar Schools Finder',
    description:
      'See which colleges consider each other peer schools, and discover similar colleges by size, selectivity, cost, and outcomes.',
    tags: ['Peer networks', 'Similar colleges', 'Public data'],
    preview: true,
  },
  {
    to: '/major-mobility-explorer',
    emoji: '🧭',
    title: 'Major Mobility Explorer',
    description:
      'See what people with a given major actually go on to do — common careers, salary ranges, where they work, and which majors lead to similar outcomes.',
    tags: ['Careers', 'Salaries', 'Geographic mobility'],
    preview: true,
  },
  {
    to: '/scholarship-opportunities',
    emoji: '✨',
    title: 'Scholarship Opportunity Finder',
    description:
      'Browse a live, curated list of scholarships with award amounts, deadlines, and direct links to official application details.',
    tags: ['Scholarships', 'Awards', 'Live deadlines'],
    preview: true,
  },
];

const Tools = () => (
  <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6">
    <header className="mb-10 max-w-2xl">
      <h1 className="text-3xl font-bold text-foreground sm:text-4xl">Tools</h1>
      <p className="mt-3 text-base text-muted-foreground">
        Free, exploratory tools that surface relationships in public education and career data — things
        that are hard to discover on your own. Pick one to get started.
      </p>
    </header>

    <div className="grid gap-6 sm:grid-cols-2">
      {TOOLS.map((tool) => (
        <Link
          key={tool.to}
          to={tool.to}
          className="group flex h-full flex-col rounded-xl border border-border bg-background p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70"
        >
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-2xl">
            <span aria-hidden="true">{tool.emoji}</span>
          </div>
          <h2 className="text-lg font-semibold text-foreground group-hover:text-primary">{tool.title}</h2>
          <p className="mt-2 text-sm text-muted-foreground">{tool.description}</p>
          <ul className="mt-4 flex flex-wrap gap-1.5">
            {tool.tags.map((tag) => (
              <li
                key={tag}
                className="rounded-full bg-muted px-2 py-0.5 text-[11px] font-medium text-muted-foreground"
              >
                {tag}
              </li>
            ))}
          </ul>
          {tool.preview ? (
            <span className="mt-4 w-fit rounded-full bg-primary/10 px-2.5 py-1 text-[11px] font-semibold text-primary">
              Free preview · Full portal access
            </span>
          ) : null}
          <span className="mt-5 text-sm font-medium text-primary">{tool.preview ? 'Preview tool →' : 'Open tool →'}</span>
        </Link>
      ))}
    </div>
  </div>
);

export default Tools;
